(function creditsScript($, Drupal) {
  Drupal.behaviors.credits = {
    attach(context) {
      document.getElementById('year').textContent = new Date().getFullYear();
    },
  };
}(jQuery, Drupal));
